"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwind = void 0;
const recipes_1 = require("../recipes");
const basic_ingredients_1 = require("./basic-ingredients");
const combine_join_1 = require("./combine-join");
const flatten_1 = require("./flatten");
const to_object_1 = require("./to-object");
exports.unwind = (0, recipes_1.unwindRecipe)({
    ...basic_ingredients_1.basic,
    flatten: flatten_1.flatten,
    combineJoin: combine_join_1.combineJoin,
    toObject: to_object_1.toObject,
    symbols: [Symbol.iterator],
});
